import { render, staticRenderFns } from "./operate-customer-baseinvoice.vue?vue&type=template&id=35ed0077&scoped=true&"
import script from "./operate-customer-baseinvoice.vue?vue&type=script&lang=js&"
export * from "./operate-customer-baseinvoice.vue?vue&type=script&lang=js&"
import style0 from "./operate-customer-baseinvoice.vue?vue&type=style&index=0&id=35ed0077&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ed0077",
  null
  
)

export default component.exports